<script>
  import Icon from '@/components/Icon';
  import Modal from '@/components/Modal';
  import { mapGetters, mapState } from 'vuex';
  import WalletWind from '@/assets/wallet-wind.svg';

  export default {
    components: {
      Icon,
      Modal,
      WalletWind,
    },

    props: {
      id: {
        type: String,
        required: true,
      },
    },

    computed: {
      ...mapGetters('coins', [
        'coin',
      ]),

      ...mapState('transaction', [
        'list',
      ]),

      selected () {
        return this.list.find(transaction => transaction.id == this.id);
      },
    },

    methods: {
      close () {
        this.$router.push('/carteira');
      },
    },
  };
</script>

<template>
  <Modal
    @close="close"
    class="wallet-show"
    >
    <Icon
      :icon="coin.title"
      class="wallet-show__icon"
      />

    <h4
      class="wallet-show__title"
      v-text="selected.quantity > 0 ? `+${selected.quantity}` : selected.quantity"
      >
    </h4>

    <p class="wallet-show__aprox">
      <WalletWind /> R$ 8.32
    </p>

    <ul class="wallet-show__list">
      <li class="wallet-show__item">
        Endereço da transação <span class="wallet-show__item-highlight wallet-show__item-bg">h2324shdas232</span>
      </li>

      <li class="wallet-show__item">
        Preço Unitário <span class="wallet-show__item-highlight" v-text="coin.formated"></span>
      </li>

      <li class="wallet-show__item">
        03/04/19 - 07:45 <span class="wallet-show__item-highlight">Pendente</span>
      </li>
    </ul>
  </Modal>
</template>

<style lang="scss">
  .wallet-show {
    .modal__wrapper {
      display: flex;
      min-width: 550px;
      align-items: center;
      flex-direction: column;
    }

    &__icon {
      height: 70px;
      margin-bottom: 40px;
    }

    &__aprox,
    &__title {
      color: #FFF;
      line-height: 1;
      font-size: 32px;
      margin-bottom: 16px;
      letter-spacing: .64px;
    }

    &__title {
      font-weight: 300;
    }

    &__aprox {
      font-weight: 500;
      margin-bottom: 56px;
    }

    &__list {
      width: 100%;
    }

    &__item {
      display: flex;
      color: #b2b8c5;
      line-height: 1.13;
      align-items: center;
      letter-spacing: .32px;
      justify-content: space-between;

      &:not(:last-child) {
        margin-bottom: 32px;
      }

      &-bg {
        padding: 8px 16px;
        border-radius: 4px;
        background-color: rgba(#FFF, .08);
      }

      &-highlight {
        color: #FFF;
      }
    }
  }
</style>
